module.exports = __webpack_public_path__ + "static/property1-9a31fde81cce79f4348e0798b603c348.png";